import { optimiseImageUrl } from '@common/utils/optimise-image/optimise-image-url.util';
import { RcFile } from 'antd/lib/upload';
import React from 'react';
import { css } from 'twin.macro';

interface IProps {
    src: string | RcFile;
    className?: string;
    width?: string | number;
    height?: string | number;
    alt?: string;
    customParams?: string;
}

// TODO in future add dpi for different screens feature
export const Image = React.forwardRef<HTMLDivElement, IProps>(({ className, ...rest }, _ref) => {
    return (
        <img
            className={className}
            src={rest.src as string}
            style={{ width: rest.width || 'auto', height: rest.height || 'auto' }}
        />
    );
});

interface IBGImageProps {
    src: string | undefined;
    className?: string;
    width?: string;
    height?: string;
    onClick?: () => void;
}

export const BGImage = ({ src, className, onClick }: IBGImageProps): JSX.Element => {
    return (
        <div
            onClick={onClick}
            className={className}
            css={imageStyles.image}
            style={{
                backgroundImage: `url('${src}')`,
            }}
        ></div>
    );
};

const imageStyles = {
    image: css`
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    `,
};

export const PrismicImage = ({ src, width, height, className, alt, customParams }: IProps): JSX.Element => {
    const optimisedImageUrl = optimiseImageUrl(src as string, width, height, customParams);
    return <img className={className} src={optimisedImageUrl} alt={alt} />;
};
